import React, { useEffect, useState } from "react";
import { OfferAttribute } from "@components/BuilderComponents/SignupFormDrip/sfd-components/Form/sfd-helpers/sfd-form.type";
import styles from "./OfferInput.module.scss";
import OfferBox from "./OfferBox";
import { useFormData } from "@sp-state/useFormData";

type OfferAttributesType = {
  offerOne?: OfferAttribute;
  offerTwo?: OfferAttribute;
  defaultOfferOne?: boolean | null;
};

const OfferInput = ({
  offerOne,
  offerTwo,
  defaultOfferOne,
}: OfferAttributesType) => {
  const [offerSelected, setOfferSelected] = useState<string | null>(null);

  const { setOfferPromoCode } = useFormData();

  useEffect(() => {
    if (defaultOfferOne) {
      setOfferSelected("1");
      setOfferPromoCode(offerOne?.promoCode || null);
    } else {
      setOfferSelected("2");
      setOfferPromoCode(offerTwo?.promoCode || null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOfferSelected = (offer: string) => {
    setOfferSelected(offer);

    const offerPromoCode =
      offer === "1" ? offerOne?.promoCode : offerTwo?.promoCode;

    setOfferPromoCode(offerPromoCode || null);
  };

  return (
    <div className={styles.container}>
      <OfferBox
        title={offerOne?.title}
        copy={offerOne?.copy}
        checked={offerSelected === "1"}
        setOfferSelected={handleOfferSelected}
        name="offerOne"
        value="1"
      />
      <OfferBox
        title={offerTwo?.title}
        copy={offerTwo?.copy}
        checked={offerSelected === "2"}
        setOfferSelected={handleOfferSelected}
        name="offerTwo"
        value="2"
        lastOne
      />
    </div>
  );
};

export default OfferInput;
